import { map, some } from "lodash-es";

import { MDSIconKind } from "@/mds";
import type { AgentFilterSelectItem } from "@/pages/agent/components/agent-filter-select";
import { formatStatusLabel } from "@/pages/agent/utils/agent-status.utils";
import {
  ALL_PROJECTS_FILTER,
  ALL_STATUSES_FILTER,
  TaskSortKey,
} from "@/pages/agent/tasks/use-agent-tasks-search-params";

export const buildTaskSortFilterItems = (): AgentFilterSelectItem[] => [
  {
    id: TaskSortKey.DueDate,
    label: "Due date",
    iconKind: MDSIconKind.SortAlt,
  },
  {
    id: TaskSortKey.RecentlyUpdated,
    label: "Recently updated",
    iconKind: MDSIconKind.SortAlt,
  },
];

export type AgentTaskProjectFilterOption = {
  id: string;
  title: string;
};

export const buildTaskProjectFilterItems = ({
  projectFilter,
  projectOptions,
}: {
  projectFilter: string;
  projectOptions: AgentTaskProjectFilterOption[];
}): AgentFilterSelectItem[] => {
  const projectFilterItems: AgentFilterSelectItem[] = [
    {
      id: ALL_PROJECTS_FILTER,
      label: "All projects",
      iconKind: MDSIconKind.Folder,
    },
  ];
  const hasSelectedProject =
    projectFilter === ALL_PROJECTS_FILTER ||
    some(projectOptions, projectOption => projectOption.id === projectFilter);

  if (!hasSelectedProject) {
    projectFilterItems.push({
      id: projectFilter,
      label: "Selected project",
      iconKind: MDSIconKind.Folder,
    });
  }

  projectFilterItems.push(
    ...map(projectOptions, projectOption => ({
      id: projectOption.id,
      label: projectOption.title,
      iconKind: MDSIconKind.Folder,
    }))
  );

  return projectFilterItems;
};

export const buildTaskStatusFilterItems = ({
  statusFilter,
  statusFilterValues,
}: {
  statusFilter: string;
  statusFilterValues: string[];
}): AgentFilterSelectItem[] => {
  const statusFilterItems: AgentFilterSelectItem[] = [
    {
      id: ALL_STATUSES_FILTER,
      label: "All statuses",
      iconKind: MDSIconKind.Filter,
    },
  ];
  const hasSelectedStatus =
    statusFilter === ALL_STATUSES_FILTER || statusFilterValues.includes(statusFilter);

  if (!hasSelectedStatus) {
    statusFilterItems.push({
      id: statusFilter,
      label: formatStatusLabel({ status: statusFilter }),
      iconKind: MDSIconKind.Filter,
    });
  }

  statusFilterItems.push(
    ...map(statusFilterValues, status => ({
      id: status,
      label: formatStatusLabel({ status }),
      iconKind: MDSIconKind.Filter,
    }))
  );

  return statusFilterItems;
};
